import { DATE_FORMAT, phoneRegExp } from "constants/appConstants";
import moment from "moment";
import * as yup from "yup";

export const getMomentDate = (date, format = DATE_FORMAT) => {
  if (moment(date).isValid()) {
    return moment(date).format(format);
  } else {
    return "NA";
  }
};

// Utility: Strip commas/non-digits
export const getRawNumberValue = (value) => {
  if (typeof value !== "string") {
    return value;
  }
  return value?.replace(/\D/g, "");
};

export const yupCleanNumberString = (value, originalValue) => {
  if (typeof originalValue === "string") {
    return getRawNumberValue(originalValue); // only digits
  }
  return value;
};

export const formatNumber = (value, country = "US") => {
  // Return empty string for null, undefined, or empty input
  if (value === null || value === undefined || value === "") return "";

  // If already a number, format it
  if (typeof value === "number") {
    return new Intl.NumberFormat(country).format(value);
  }

  // If it's a string, remove non-numeric characters (like $ or , or spaces)
  const numericString = value.replace(/[^\d.-]/g, ""); // Allow decimal and negative signs

  // Parse it as a number
  const parsed = parseFloat(numericString);

  // If parsing fails, return original input (could be invalid string like 'abc')
  if (isNaN(parsed)) return value;

  return new Intl.NumberFormat(country).format(parsed);
};

export const fieldsValidation = {
  number: (fieldName) => yup.string().transform(yupCleanNumberString),
  mobile: (fieldName) =>
    yup
      .string(
        `Enter a valid ${fieldName || "mobile number"} in (XXX) XXX-XXXX format`
      )
      .matches(
        phoneRegExp,
        "Phone number is not valid. enter in valid format (Xxx) Xxx-Xxxx"
      ),
};
